import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  MenuItem,
} from '@mui/material';
import 'dayjs/locale/ko'; 
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';
import * as dayjs from 'dayjs'


const OrderSheetForm = ({ sellPartnerOptions, formik }) => {
  const [sheetCrtDate, setSheetCrtDate] = useState(null);

  useEffect(() => {
    if (formik.values?.sheetCrtDate) {
      setSheetCrtDate(formik.values.sheetCrtDate);
    }
  }, [formik.values?.sheetCrtDate]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={3}>
          <FormControl
            fullWidth
            error={
              formik.touched.sellPartnerUuid &&
              Boolean(formik.errors.sellPartnerUuid)
            }
          >
            <Select
              inputProps={{ 'aria-label': '매출처' }}
              value={formik.values.sellPartnerUuid}
              onChange={(e) =>
                formik.setFieldValue('sellPartnerUuid', e.target.value)
              }
              displayEmpty
            >
              <MenuItem value="">
                <em>매입처를 선택하세요</em>
              </MenuItem>
              {sellPartnerOptions &&
                sellPartnerOptions.length > 0 &&
                sellPartnerOptions.map((option) => (
                  <MenuItem
                    key={option.sellPartnerUuid}
                    value={option.sellPartnerUuid}
                  >
                    {option.sellPartnerNm}
                  </MenuItem>
                ))}
            </Select>
            <FormHelperText>
              {formik.touched.sellPartnerUuid && formik.errors.sellPartnerUuid}
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={3}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            required
            id="orderSheetNo"
            name="orderSheetNo"
            label="발주번호"
            InputLabelProps={{ shrink: true }}
            value={formik.values.orderSheetNo}
            onChange={formik.handleChange}
            error={
              formik.touched.orderSheetNo && Boolean(formik.errors.orderSheetNo)
            }
            helperText={
              formik.touched.orderSheetNo && formik.errors.orderSheetNo
            }
          />
        </Grid>
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              label="발주일자"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="sheetCrtDate"
              name="sheetCrtDate"
              value={dayjs(sheetCrtDate)}
              onChange={(newValue) => {
                setSheetCrtDate(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'sheetCrtDate');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required={false}
                  fullWidth
                  error={
                    formik.touched.sheetCrtDate &&
                    Boolean(formik.errors.sheetCrtDate)
                  }
                  helperText={
                    formik.touched.sheetCrtDate && formik.errors.sheetCrtDate
                  }
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={3}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="sheetUsrNm"
            name="sheetUsrNm"
            label="담당자명"
            value={formik.values.sheetUsrNm}
            onChange={formik.handleChange}
            error={
              formik.touched.sheetUsrNm && Boolean(formik.errors.sheetUsrNm)
            }
            helperText={formik.touched.sheetUsrNm && formik.errors.sheetUsrNm}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="sheetUsrTel"
            name="sheetUsrTel"
            label="담당자 연락처"
            value={formik.values.sheetUsrTel}
            onChange={formik.handleChange}
            error={
              formik.touched.sheetUsrTel && Boolean(formik.errors.sheetUsrTel)
            }
            helperText={formik.touched.sheetUsrTel && formik.errors.sheetUsrTel}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            required
            fullWidth
            id="sheetCstNm"
            name="sheetCstNm"
            label="사업명"
            InputLabelProps={{ shrink: true }}
            value={formik.values.sheetCstNm}
            onChange={formik.handleChange}
            error={
              formik.touched.sheetCstNm && Boolean(formik.errors.sheetCstNm)
            }
            helperText={formik.touched.sheetCstNm && formik.errors.sheetCstNm}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={6}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            required
            id="sheetPayCond"
            name="sheetPayCond"
            label="결제 조건"
            InputLabelProps={{ shrink: true }}
            value={formik.values.sheetPayCond}
            onChange={formik.handleChange}
            error={
              formik.touched.sheetPayCond && Boolean(formik.errors.sheetPayCond)
            }
            helperText={
              formik.touched.sheetPayCond && formik.errors.sheetPayCond
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            required
            id="sheetPeriod"
            name="sheetPeriod"
            label="납기"
            InputLabelProps={{ shrink: true }}
            value={formik.values.sheetPeriod}
            onChange={formik.handleChange}
            error={
              formik.touched.sheetPeriod && Boolean(formik.errors.sheetPeriod)
            }
            helperText={formik.touched.sheetPeriod && formik.errors.sheetPeriod}
          />
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            required={false}
            fullWidth
            multiline
            rows={3}
            id="sheetDesc"
            name="sheetDesc"
            label="기타사항"
            InputLabelProps={{ shrink: true }}
            value={formik.values.sheetDesc}
            onChange={formik.handleChange}
            error={formik.touched.sheetDesc && Boolean(formik.errors.sheetDesc)}
            helperText={formik.touched.sheetDesc && formik.errors.sheetDesc}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderSheetForm;
